import { render } from "./Volunteer.vue?vue&type=template&id=57bc0bbb&scoped=true"
import script from "./Volunteer.vue?vue&type=script&lang=js"
export * from "./Volunteer.vue?vue&type=script&lang=js"

import "./Volunteer.vue?vue&type=style&index=0&id=57bc0bbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bc0bbb"]])

export default __exports__